import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { DependencySmallIcon } from "@activecollab/components";
import PropTypes from "prop-types";
import { getRawConfigOption } from "~/store/selectors/selector.configOptions";
import { makeGetOpenDependenciesCountByIdSelector } from "~/store/selectors/selector.tasks";
import TaskObjectsCount from "./TaskObjectsCount";

export const DependenciesCount = ({ id }) => {
  const getOpenDependenciesCountById = useMemo(makeGetOpenDependenciesCountByIdSelector, []);
  const count = useSelector((state) => getOpenDependenciesCountById(state, id));
  const isTaskDependenciesEnabled = useSelector((state) => getRawConfigOption(state, "task_dependencies_enabled"));
  return count > 0 && isTaskDependenciesEnabled ? (
    <TaskObjectsCount
      iconType={DependencySmallIcon}
      count={count}
    />
  ) : null;
};

DependenciesCount.propTypes = {
  id: PropTypes.oneOfType([
    PropTypes.string, // string is used as placeholder ID until backend returns the real ID
    PropTypes.number,
  ]),
};
